import './WarningIcon.scss';

export function WarningIcon() {
  return <div className={`warning-icon-container`}>!</div>;
}
